<template>
    <div
        class="dropdown is-right action pointer"
        :class="{'is-active': show_dropdown}"
        @mouseleave="show_dropdown = false">

        <div @click="toggle_dropdown" class="dropdown-trigger">
            <slot></slot>
        </div>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <div class="dropdown-item">
                    <base-input
                        v-model="search_query"
                        :loading="list.loading"
                        @input="search"
                        name="search"
                        icon="fas fa-search"
                        placeholder="Search Tags..."
                        autocomplete="off" ref="search_form"/>
                </div>

                <hr class="dropdown-divider"/>

                <a v-for="tag in list.data.results"
                   :key="tag.id"
                   @click="select(tag)"
                   class="dropdown-item">
                    <tag :name="tag.name" :color="tag.color"/>
                </a>

                <div v-if="list.data.results && !list.data.results.length" class="dropdown-item">
                    <p>No tags found</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import Tag from './Tag.vue';

export default {
    name: 'TagPicker',
    components: { Tag },
    props: ['space', 'exclude'],
    data() {
        return { search_query: null, show_dropdown: false, loaded: false };
    },
    computed: mapState('tags', ['list']),
    watch: {
        exclude() {
            // reload next time if 'exclude' was changed
            this.loaded = false;
        },
    },
    methods: {
        search: debounce(function (search) {
            this.load(search);
        }, 500),
        toggle_dropdown() {
            this.show_dropdown = !this.show_dropdown;
            if (this.show_dropdown) {
                this.$nextTick(() => this.$refs.search_form.$refs.input.focus());
                this.first_load();
            }
        },
        first_load() {
            if (!this.loaded) {
                this.load();
                this.loaded = true;
            }
        },
        load(search = null) {
            this.$store.dispatch('tags/list', {
                exclude_ids: this.exclude,
                space_id: this.space.id,
                search,
            });
        },
        select(tag) {
            // refresh component data
            Object.assign(this.$data, this.$options.data());
            this.$emit('select', tag);
        },
    },
};
</script>
